import { useState } from "react";
import { useRecordContext, ArrayField, Datagrid, TextField, Button, SimpleShowLayout } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { settings } from "app";
import ProfessorField from "server/components/Fields/ProfessorField";
import ProfessorsEditForm from "./ProfessorsEditForm";

const ProfessorsSection = () => {
  const record = useRecordContext();
  const [isEditing, setIsEditing] = useState(false);
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <SimpleShowLayout>
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        {isEditing ? (
          <Grid
            item
            xs={12}
          >
            <ProfessorsEditForm
              record={record}
              setIsEditing={setIsEditing}
            />
          </Grid>
        ) : (
          <>
            <Grid
              item
              xs={12}
              md={6}
            >
              <ArrayField
                source="professors"
                label=""
              >
                <Datagrid
                  bulkActionButtons={false}
                  rowClick={false}
                  sx={settings.style.detailsDatagrid}
                >
                  <ProfessorField
                    source="employeeId"
                    label="Преподавател"
                  />

                  <TextField
                    source="externalEmployeeNames"
                    label="Имена (външни)"
                  />
                </Datagrid>
              </ArrayField>
            </Grid>
            <Grid
              item
              xs={12}
            >
              <SecuredComponent permission={permissions.canUpdateAdvancedSpecializationsProfessors}>
                <Button
                  variant="contained"
                  startIcon={<EditIcon />}
                  label="Редактирай"
                  onClick={() => setIsEditing(v => !v)}
                />
              </SecuredComponent>
            </Grid>
          </>
        )}
      </Grid>
    </SimpleShowLayout>
  );
};

export default ProfessorsSection;
